import { Loader } from '@bordrio/ui-components';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './app/App';

import './i18n';

import './index.css';
import 'flag-icons/css/flag-icons.min.css';
import '@bordrio/ui-components/global.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element');
}
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <React.Suspense fallback={<Loader />}>
      <App />
    </React.Suspense>
  </React.StrictMode>,
);
